import angular from 'angular';

RetailController.$inject = ['$scope'];
function RetailController($scope) {
  const ctrl = {
    model: 'Your spankin new application.retail view!',

    init: function () {},

    success: {
      init: function (response) {},
    },

    error: {
      init: function (response) {},
    },
  };

  $scope.retail = ctrl;
  $scope.retail.init();
}

export const RetailControllerModule = angular
  .module('acme.view.application.retail.controllers', [])
  .controller('RetailController', RetailController).name;
